var _mask, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgress7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_381_486",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.5679 1.86974e-08 13.1139 0.368692 14.5131 1.07631C15.9122 1.78392 17.1254 2.81063 18.0546 4.07354C18.9839 5.33645 19.6031 6.80017 19.8624 8.34651C20.1216 9.89286 20.0136 11.4785 19.5471 12.9754C19.0806 14.4723 18.2686 15.8386 17.1767 16.9638C16.0848 18.0891 14.7436 18.9418 13.2615 19.4532C11.7793 19.9646 10.1976 20.1202 8.64414 19.9077C7.09069 19.6951 5.609 19.1202 4.31869 18.2294L10 10L10 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.5679 1.86974e-08 13.1139 0.368692 14.5131 1.07631C15.9122 1.78392 17.1254 2.81063 18.0546 4.07354C18.9839 5.33645 19.6031 6.80017 19.8624 8.34651C20.1216 9.89286 20.0136 11.4785 19.5471 12.9754C19.0806 14.4723 18.2686 15.8386 17.1767 16.9638C16.0848 18.0891 14.7436 18.9418 13.2615 19.4532C11.7793 19.9646 10.1976 20.1202 8.64414 19.9077C7.09069 19.6951 5.609 19.1202 4.31869 18.2294L10 10L10 0Z",
    fill: "#09702B",
    stroke: "#09702B",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_381_486)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    transform: "rotate(-90 10 10)",
    stroke: "#09702B",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress7);
export default __webpack_public_path__ + "static/media/progress7.4816485fb2c5f13d8072e62ed5c5f5dd.svg";
export { ForwardRef as ReactComponent };